"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OverlappingCard_st_css_1 = require("./OverlappingCard.st.css");
var Card_1 = require("../Card");
exports.OverlappingCardRatioOptions = Card_1.CardRatioOptions;
var deprecationLog_1 = require("../../common/deprecationLog");
var OverlappingCard = function (_a) {
    var info = _a.info, media = _a.media, ratio = _a.ratio, invertInfoPosition = _a.invertInfoPosition, flippedRatio = _a.flippedRatio, rest = __rest(_a, ["info", "media", "ratio", "invertInfoPosition", "flippedRatio"]);
    deprecationLog_1.deprecationLog('OverlappingCard', 'The current `Card` component API will be deprecated in the next major version. Please use the `upgrade` prop in order to use the new API.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--newcard');
    return (React.createElement("div", __assign({}, OverlappingCard_st_css_1.default('root', {
        ratio: media ? ratio : Card_1.CardRatioOptions.RATIO_100,
        invertInfoPosition: invertInfoPosition,
        flippedRatio: flippedRatio,
    }, rest)),
        media && ratio !== Card_1.CardRatioOptions.RATIO_100 && (React.createElement("div", { className: OverlappingCard_st_css_1.default.mediaContainer }, media)),
        info && React.createElement("div", { className: OverlappingCard_st_css_1.default.infoContainer }, info)));
};
exports.OverlappingCard = OverlappingCard;
OverlappingCard.displayName = 'OverlappingCard';
OverlappingCard.MIN_WIDTH = 700;
OverlappingCard.defaultProps = {
    ratio: Card_1.CardRatioOptions.RATIO_50_50,
    flippedRatio: false,
    invertInfoPosition: false,
};
//# sourceMappingURL=OverlappingCard.js.map